// Visualization2 CP-1A Page - Hardcoded Configuration
import React, { useState, useEffect, useCallback } from 'react';
import { Header } from '../components/Header';
import { useAuthContext as useAuth } from '../contexts/AuthContext';
import { permissionChecks } from '../lib/auth/helpers';
import { CPConfig, SequenceConfig } from '../types/config';
import { VisualizationEngine } from '../components/visualization/VisualizationEngine';
import { thresholdService, ThresholdServiceStatic } from '../services/thresholdService';
import { OccupancyServiceStatic } from '../services/occupancyService';

// CP-1A Configuration from JSON - Redesigned (73x37 grid, right to left flow)
const cp1aConfig: CPConfig = {
  grids: {
    x: 73,
    y: 37
  },
  assets: {
    metaldetectors: [
      { x: 18, y: 8.5 },
      { x: 18, y: 17 },
      { x: 18, y: 26 }
    ],
    bodyscanner: [
      { x: 15, y: 8.5 },
      { x: 15, y: 17 },
      { x: 15, y: 26 }
    ],
    conveyorbelt: [
      { start: { x: 8, y: 5 }, end: { x: 18, y: 5 } },
      { start: { x: 8, y: 12 }, end: { x: 18, y: 12 } },
      { start: { x: 8, y: 13 }, end: { x: 18, y: 13 } },
      { start: { x: 8, y: 20.5 }, end: { x: 18, y: 20.5 } },
      { start: { x: 8, y: 22 }, end: { x: 18, y: 22 } },
      { start: { x: 8, y: 29.5 }, end: { x: 18, y: 29.5 } }
    ]
  },
  heatmap: {
    "t1-1a_s1-1_z01": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 8, y: 27 },
        { x: 18, y: 27 },
        { x: 18, y: 29 },
        { x: 8, y: 29 }
      ],
      passengerPath: [
        { x: 18, y: 28 },
        { x: 16, y: 28 },
        { x: 14, y: 28 },
        { x: 12, y: 28 },
        { x: 10, y: 28 },
        { x: 8, y: 28 }
      ]
    },
    "t1-1a_s1-1_z02": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 8, y: 23 },
        { x: 18, y: 23 },
        { x: 18, y: 25 },
        { x: 8, y: 25 }
      ],
      passengerPath: [
        { x: 18, y: 24 },
        { x: 16, y: 24 },
        { x: 14, y: 24 },
        { x: 12, y: 24 },
        { x: 10, y: 24 },
        { x: 8, y: 24 }
      ]
    },
    "t1-1a_s1-1_z03": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 8, y: 18 },
        { x: 18, y: 18 },
        { x: 18, y: 20 },
        { x: 8, y: 20 }
      ],
      passengerPath: [
        { x: 18, y: 19 },
        { x: 16, y: 19 },
        { x: 14, y: 19 },
        { x: 12, y: 19 },
        { x: 10, y: 19 },
        { x: 8, y: 19 }
      ]
    },
    "t1-1a_s1-1_z04": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 8, y: 14 },
        { x: 18, y: 14 },
        { x: 18, y: 16 },
        { x: 8, y: 16 }
      ],
      passengerPath: [
        { x: 18, y: 15 },
        { x: 16, y: 15 },
        { x: 14, y: 15 },
        { x: 12, y: 15 },
        { x: 10, y: 15 },
        { x: 8, y: 15 }
      ]
    },
    "t1-1a_s1-1_z05": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 8, y: 9 },
        { x: 18, y: 9 },
        { x: 18, y: 11 },
        { x: 8, y: 11 }
      ],
      passengerPath: [
        { x: 18, y: 10 },
        { x: 16, y: 10 },
        { x: 14, y: 10 },
        { x: 12, y: 10 },
        { x: 10, y: 10 },
        { x: 8, y: 10 }
      ]
    },
    "t1-1a_s1-1_z06": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 8, y: 6 },
        { x: 18, y: 6 },
        { x: 18, y: 8 },
        { x: 8, y: 8 }
      ],
      passengerPath: [
        { x: 18, y: 7 },
        { x: 16, y: 7 },
        { x: 14, y: 7 },
        { x: 12, y: 7 },
        { x: 10, y: 7 },
        { x: 8, y: 7 }
      ]
    },
    "t1-1a_s1-2_z01": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 21, y: 27 },
        { x: 31, y: 27 },
        { x: 31, y: 29 },
        { x: 21, y: 29 }
      ],
      passengerPath: [
        { x: 31, y: 28 },
        { x: 29, y: 28 },
        { x: 27, y: 28 },
        { x: 25, y: 28 },
        { x: 23, y: 28 },
        { x: 21, y: 28 }
      ]
    },
    "t1-1a_s1-2_z02": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 21, y: 23 },
        { x: 31, y: 23 },
        { x: 31, y: 25 },
        { x: 21, y: 25 }
      ],
      passengerPath: [
        { x: 31, y: 24 },
        { x: 29, y: 24 },
        { x: 27, y: 24 },
        { x: 25, y: 24 },
        { x: 23, y: 24 },
        { x: 21, y: 24 }
      ]
    },
    "t1-1a_s1-2_z03": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 21, y: 18 },
        { x: 31, y: 18 },
        { x: 31, y: 20 },
        { x: 21, y: 20 }
      ],
      passengerPath: [
        { x: 31, y: 19 },
        { x: 29, y: 19 },
        { x: 27, y: 19 },
        { x: 25, y: 19 },
        { x: 23, y: 19 },
        { x: 21, y: 19 }
      ]
    },
    "t1-1a_s1-2_z04": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 21, y: 14 },
        { x: 31, y: 14 },
        { x: 31, y: 16 },
        { x: 21, y: 16 }
      ],
      passengerPath: [
        { x: 31, y: 15 },
        { x: 29, y: 15 },
        { x: 27, y: 15 },
        { x: 25, y: 15 },
        { x: 23, y: 15 },
        { x: 21, y: 15 }
      ]
    },
    "t1-1a_s1-2_z05": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 21, y: 9 },
        { x: 31, y: 9 },
        { x: 31, y: 11 },
        { x: 21, y: 11 }
      ],
      passengerPath: [
        { x: 31, y: 10 },
        { x: 29, y: 10 },
        { x: 27, y: 10 },
        { x: 25, y: 10 },
        { x: 23, y: 10 },
        { x: 21, y: 10 }
      ]
    },
    "t1-1a_s1-2_z06": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 21, y: 6 },
        { x: 31, y: 6 },
        { x: 31, y: 8 },
        { x: 21, y: 8 }
      ],
      passengerPath: [
        { x: 31, y: 7 },
        { x: 29, y: 7 },
        { x: 27, y: 7 },
        { x: 25, y: 7 },
        { x: 23, y: 7 },
        { x: 21, y: 7 }
      ]
    },
    "t1-1a_s2_z02": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Standard"],
      tagLabel: [                      // NEW: for canvas rendering
        {
          "text": "Standard",
          "start": {"x": 31, "y": 30},
          "end": {"x": 35, "y": 30}
        }],
      polygon: [
        { x: 31, y: 9 },
        { x: 35, y: 9 },
        { x: 35, y: 29 },
        { x: 31, y: 29 }
      ],
      "passengerPath": [
      { "x": 34, "y": 28 },
      { "x": 34, "y": 26 },
      { "x": 34, "y": 24 },
      { "x": 32, "y": 24 },
      { "x": 34, "y": 24 },
      { "x": 34, "y": 21.5 },
      { "x": 34, "y": 19 },
      { "x": 32, "y": 19 },
      { "x": 34, "y": 19 },
      { "x": 34, "y": 17 },
      { "x": 34, "y": 15 },
      { "x": 32, "y": 15 },
      { "x": 34, "y": 15 },
      { "x": 34, "y": 12.5 },
      { "x": 34, "y": 10 },
      { "x": 32, "y": 10 }
      ]
    },
    "t1-1a_s3_a01": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Standard"],
      tagLabel: [                      // NEW: for canvas rendering
        {
          "text": "Standard",
          "start": {"x": 40, "y": 14},
          "end": {"x": 45, "y": 14}
        }],
      polygon: [
        { x: 35, y: 8 },
        { x: 40, y: 8 },
        { x: 40, y: 11 },
        { x: 43, y: 16 },
        { x: 43, y: 29 },
        { x: 37, y: 29 },
        { x: 37, y: 26 },
        { x: 35, y: 26 }
      ],
      passengerPath: [
        { x: 44, y: 15 },
        { x: 43, y: 15 },
        { x: 42, y: 15 },
        { x: 42, y: 17 },
        { x: 42, y: 19 },
        { x: 42, y: 21 },
        { x: 42, y: 23 },
        { x: 42, y: 25 },
        { x: 42, y: 27 },
        { x: 38, y: 27 },
        { x: 38, y: 25 },
        { x: 38, y: 23 },
        { x: 38, y: 21 },
        { x: 38, y: 19 },
        { x: 38, y: 17 },
        { x: 36, y: 17 },
        { x: 36, y: 15 },
        { x: 35, y: 15 }
      ]
    },
    "t1-1a_s3_a02": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Business"],
      tagLabel: [                      // NEW: for canvas rendering
        {
          "text": "Business",
          "start": {"x": 30, "y": 5.5},
          "end": {"x": 37, "y": 5.5}
        }],
      polygon: [
        { x: 35.5, y: 5 },
        { x: 43, y: 5 },
        { x: 43, y: 11.5 },
        { x: 42, y: 11.5 },
        { x: 42, y: 6 },
        { x: 35.5, y: 6 }
      ],
      passengerPath: [
        { x: 42.5, y: 11.5 },
        { x: 42.5, y: 10.5 },
        { x: 42.5, y: 9.5 },
        { x: 42.5, y: 8.5 },
        { x: 42.5, y: 7.5 },
        { x: 42.5, y: 6.5 },
        { x: 42.5, y: 5.5 },
        { x: 41.5, y: 5.5 },
        { x: 40.5, y: 5.5 },
        { x: 39.5, y: 5.5 },
        { x: 38.5, y: 5.5 },
        { x: 37.5, y: 5.5 },
        { x: 36.5, y: 5.5 },
        { x: 35.5, y: 5.5 }
      ]
    },
    "t1-1a_s3_a03": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Clear"],
      tagLabel: [                      // NEW: for canvas rendering
        {
          "text": "Clear",
          "start": {"x": 30, "y": 4.5},
          "end": {"x": 37, "y": 4.5}
        }],
      polygon: [
        { x: 35.5, y: 4 },
        { x: 44, y: 4 },
        { x: 44, y: 11.5 },
        { x: 43, y: 11.5 },
        { x: 43, y: 5 },
        { x: 35.5, y: 5 }
      ],
      passengerPath: [
        { x: 43.5, y: 11.5 },
        { x: 43.5, y: 10.5 },
        { x: 43.5, y: 9.5 },
        { x: 43.5, y: 8.5 },
        { x: 43.5, y: 7.5 },
        { x: 43.5, y: 6.5 },
        { x: 43.5, y: 5.5 },
        { x: 43.5, y: 4.5 },
        { x: 42.5, y: 4.5 },
        { x: 41.5, y: 4.5 },
        { x: 40.5, y: 4.5 },
        { x: 39.5, y: 4.5 },
        { x: 38.5, y: 4.5 },
        { x: 37.5, y: 4.5 },
        { x: 36.5, y: 4.5 },
        { x: 35.5, y: 4.5 }
      ]
    },
    "t1-1a_s3_a04": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["TSA Precheck"],
      tagLabel: [                      // NEW: for canvas rendering
        {
          "text": "TSA Precheck",
          "start": {"x": 36, "y": 31},
          "end": {"x": 43, "y": 31}
        }],
      polygon: [
        { x: 43, y: 17 },
        { x: 44, y: 17 },
        { x: 44, y: 30 },
        { x: 35.5, y: 30 },
        { x: 35.5, y: 27 },
        { x: 36.5, y: 27 },
        { x: 36.5, y: 29 },
        { x: 43, y: 29 }
      ],
      passengerPath: [
        { x: 43.5, y: 17 },
        { x: 43.5, y: 18 },
        { x: 43.5, y: 19 },
        { x: 43.5, y: 20 },
        { x: 43.5, y: 21 },
        { x: 43.5, y: 22 },
        { x: 43.5, y: 23 },
        { x: 43.5, y: 24 },
        { x: 43.5, y: 25 },
        { x: 43.5, y: 26 },
        { x: 43.5, y: 27 },
        { x: 43.5, y: 28 },
        { x: 43.5, y: 29 },
        { x: 43.5, y: 29.5 },
        { x: 42.5, y: 29.5 },
        { x: 41.5, y: 29.5 },
        { x: 40.5, y: 29.5 },
        { x: 39.5, y: 29.5 },
        { x: 38.5, y: 29.5 },
        { x: 37.5, y: 29.5 },
        { x: 36.5, y: 29.5 },
        { x: 36, y: 29.5 },
        { x: 36, y: 28 },
        { x: 36, y: 27 }
      ]
    },
    "t1-1a_s4_a01": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Clear"],
      tagLabel: [                      // NEW: for canvas rendering
        {
          "text": "Clear",
          "start": {"x": 46, "y": 19.6},
          "end": {"x": 51.75, "y": 24.6}
        }],
      polygon: [
        { x: 51.2, y: 23 },
        { x: 58.9, y: 30 },
        { x: 58.1, y: 31 },
        { x: 50.3, y: 24 }
      ],
      passengerPath: [
        { x: 58, y: 30.15 },
        { x: 57, y: 29.2 },
        { x: 56.35, y: 28.6 },
        { x: 55, y: 27.35 },
        { x: 54.25, y: 26.65 },
        { x: 53.15, y: 25.6 },
        { x: 52, y: 24.57 },
        { x: 50.9, y: 23.55 }
      ]
    },
    "t1-1a_s4_a02": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Standard"],
      tagLabel: [                      // NEW: for canvas rendering
        {
          "text": "Standard",
          "start": {"x": 46.9, "y": 18.6},
          "end": {"x": 52.65, "y": 23.6}
        }],
      polygon: [
        { x: 52.1, y: 22 },
        { x: 59.7, y: 29 },
        { x: 58.9, y: 30 },
        { x: 51.2, y: 23 }
      ],
      passengerPath: [
        { x: 58.75, y: 29.05 },
        { x: 57.75, y: 28.12 },
        { x: 57, y: 27.4 },
        { x: 55.85, y: 26.35 },
        { x: 54.4, y: 25 },
        { x: 53.1, y: 23.8 },
        { x: 52.2, y: 22.95 },
        { x: 51.75, y: 22.55 }
      ]
    },
    "t1-1a_s4_a03": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Business"],
      tagLabel: [
  {
    "text": "Business",
    "start": {"x": 47.8, "y": 17.6},
    "end": {"x": 53.55, "y": 22.6}
  }
],
      polygon: [
        { x: 53, y: 21 },
        { x: 60.5, y: 28 },
        { x: 59.7, y: 29 },
        { x: 52.1, y: 22 }
      ],
      passengerPath: [
        { x: 59.8, y: 28.26 },
        { x: 59.26, y: 27.74 },
        { x: 58.37, y: 26.91 },
        { x: 57.49, y: 26.09 },
        { x: 56.71, y: 25.36 },
        { x: 55.72, y: 24.43 },
        { x: 54.50, y: 23.29 },
        { x: 52.5, y: 21.43 }
      ]
    },
    "t1-1a_s5_a01": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Standard"],
      tagLabel: [
  {
    "text": "Standard",
    "start": {"x": 61, "y": 34},
    "end": {"x": 66, "y": 34}
  }
],
      polygon: [
        { x: 58.1, y: 31 },
        { x: 63.2, y: 35 },
        { x: 63.2, y: 36.5 },
        { x: 57.2, y: 37 },
        { x: 57.2, y: 34 }
      ],
      "passengerPath": [
      { "x": 60.2, "y": 36.5 },
      { "x": 60.2, "y": 35.5 },
      { "x": 60.2, "y": 34.5 },
      { "x": 60.2, "y": 33.5 }
    ]
    }
  },
  metadata: {
    checkpointId: "cp-1a",
    name: "Checkpoint 1A", 
    terminal: "T1-1A",
    gridUnit: "meter",
    description: "Security checkpoint layout with multiple lanes and processing areas"
  }
};

// Updated sequence config for redesigned visualization
const sequenceConfig: SequenceConfig = {
  layerSequence: {
    description: "Layer rendering sequence configuration - Grid → Heatmap Polygons → Assets",
    layers: {
      "1": { name: "Base Grid", description: "Grid lines and coordinates", enabled: true, zIndex: 1 },
      "2": { name: "Heatmap Polygons", description: "Filled polygon areas with occupancy colors", enabled: true, zIndex: 2 },
      "3": { name: "Assets", description: "Metal detectors, body scanners, conveyor belts", enabled: true, zIndex: 3 }
    }
  },
  renderingOptions: {
    enableLayerToggle: false,
    defaultVisibleLayers: ["1", "2", "3"],
    animationSpeed: 1000
  }
};
// Mock occupancy data removed - using live API data only

export const Visualization2CP1APage: React.FC = () => {
  const { user } = useAuth();
  const [currentOccupancyData, setCurrentOccupancyData] = useState<Record<string, number> | null>(null);
  const [currentFlowData, setCurrentFlowData] = useState<Record<string, number> | null>(null);
  const [apiThresholds, setApiThresholds] = useState<Record<string, { green: number; yellow: number; amber: number; minflow: number; maxflow: number }> | null>(null);
  const [isLoadingThresholds, setIsLoadingThresholds] = useState(false);
  const [thresholdLoadError, setThresholdLoadError] = useState<string | null>(null);
  const [thresholdSource, setThresholdSource] = useState<'api' | 'cache' | 'default'>('default');
  const [occupancyError, setOccupancyError] = useState<string | null>(null);
  const [isLoadingOccupancy, setIsLoadingOccupancy] = useState(true);

  // Check 2D view permission
  const hasAccess = permissionChecks.can2dVisualisationAccess();

  // Subscribe to occupancy data updates
  useEffect(() => {
    // Start periodic fetch
    OccupancyServiceStatic.startPeriodicFetch();
    
    // Subscribe to data updates
    const unsubscribe = OccupancyServiceStatic.subscribe((data, error) => {
      if (data) {
        setCurrentOccupancyData(data.occupancy);
        setCurrentFlowData(data.flowOut);
        setIsLoadingOccupancy(false);
        setOccupancyError(null);
      } else if (error) {
        setOccupancyError(error);
        if (!OccupancyServiceStatic.hasData()) {
          setIsLoadingOccupancy(false);
        }
        console.error('CP-1A: Occupancy error:', error);
      }
    });

    // Cleanup on unmount
    return () => {
      unsubscribe();
    };
  }, []);

  // Updated threshold fetching with automatic refresh
  const fetchThresholds = async (isAutoRefresh = false) => {
    if (!isAutoRefresh) {
      setIsLoadingThresholds(true);
    }
    setThresholdLoadError(null);
    
    try {
      const thresholds = await thresholdService.getThresholds();
      
      // Filter for CP-1A thresholds only
      const cp1aThresholds = Object.fromEntries(
        Object.entries(thresholds).filter(([assetCode]) => assetCode.startsWith('t1-1a_'))
      );
      
      setApiThresholds(cp1aThresholds);
      
      // Determine source for status display
      const cached = ThresholdServiceStatic.getCachedThresholds();
      if (cached && Object.keys(cached).length > 0) {
        setThresholdSource('cache');
      } else if (Object.keys(cp1aThresholds).length > 0) {
        setThresholdSource('api');
      } else {
        setThresholdSource('default');
      }
      
      // Thresholds loaded successfully
      
    } catch (error) {
      setThresholdLoadError('Failed to load threshold configuration');
      setThresholdSource('default');
      setApiThresholds(null);
    } finally {
      if (!isAutoRefresh) {
        setIsLoadingThresholds(false);
      }
    }
  };

  // Auto-refresh callback for periodic updates
  const handleAutoRefresh = useCallback((thresholds: any) => {
    fetchThresholds(true); // Silent refresh
  }, []);

  // Load thresholds on mount and start periodic refresh
  useEffect(() => {
    fetchThresholds();
    
    // Start automatic refresh with callback
    ThresholdServiceStatic.startPeriodicRefresh(handleAutoRefresh);
    
    // Cleanup on unmount
    return () => {
      ThresholdServiceStatic.stopPeriodicRefresh();
    };
  }, [handleAutoRefresh]);

  // If no access, show permission denied
  if (!hasAccess) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-4">Access Denied</h1>
          <p className="text-gray-400">You don't have permission to access 2D View features.</p>
          <p className="text-gray-500 text-sm mt-2">Required permission: 2d_visualisation_access</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 relative bg-gray-900">
      {/* Local loading indicator for thresholds */}
      {isLoadingThresholds && (
        <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-2 rounded-md text-sm z-10">
          Loading thresholds...
        </div>
      )}
      
      {/* Loading indicator for occupancy data */}
      {isLoadingOccupancy && (
        <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-2 rounded-md text-sm z-10">
          Loading occupancy data...
        </div>
      )}
      
      {/* Threshold error indicator */}
      {thresholdLoadError && (
        <div className="absolute top-4 left-4 bg-yellow-600 text-white px-3 py-2 rounded-md text-sm z-10">
          {thresholdLoadError} - Using defaults
        </div>
      )}
      
      {/* Occupancy error indicator */}
      {occupancyError && (
        <div className="absolute top-4 right-4 bg-orange-600 text-white px-3 py-2 rounded-md text-sm z-10">
          Data connection issues
        </div>
      )}

      <VisualizationEngine
        checkpointConfig={cp1aConfig}
        sequenceConfig={sequenceConfig}
        occupancyData={currentOccupancyData}
        flowData={currentFlowData}
        thresholds={apiThresholds || undefined}
        checkpointId="cp-1a"
        className="w-full h-full"
      />
    </div>
  );
};